<template>
	<section
		class="w-100 d-flex flex-column align-items-center lap-margins mob-margins"
	>
		<span class="cvs-grey-txt d-flex align-items-center mb-2"
			>Keep your ID card and your face in one frame
			<img
				id="popover-button-event"
				class="ml-2 svg-box-shadow"
				src="@/assets/newdesign/cvs/greyInfo.svg"
				alt=""
			/>
			<b-popover
				ref="popover"
				target="popover-button-event"
				placement="bottom"
				triggers="hover"
			>
				<img src="@/assets/newdesign/cvs/tooltipImage.svg" alt="" />
				<h6 class="cvs-grey-txt-2 mt-1">
					Please make sure that your face and <br />
					ID is visible in same frame like this
				</h6>
			</b-popover>
		</span>
		<b-overlay
			:show="isProcessing"
			variant="transparent"
			class="d-flex align-items-center w-100 justify-content-center"
		>
			<div class="cvs-image-preview position-relative">
				<video
					v-show="!isPhotoTaken"
					id="selfieCam"
					ref="camera"
					autoplay
					muted
					class="w-100 h-100"
					style="object-fit: unset; transform: scaleX(-1)"
					allowfullscreen="false"
					playsinline
				></video>
				<canvas
					v-show="isPhotoTaken"
					style="object-fit: unset; transform: scaleX(-1)"
					id="photoTaken"
					ref="canvas"
					class="h-100 w-100"
				>
				</canvas>
				<div v-show="isVerified" class="cvs-verified-div">
					<div class="slide-in-from-right">
						<img src="@/assets/newdesign/cvs/verified.svg" alt="" />
					</div>
				</div>
			</div>
		</b-overlay>
		<span
			class="cvs-black-txt-4 mt-2"
			v-if="!isProcessing && !showWarning && !isVerified"
			>Please sit straight...</span
		>
		<span
			class="cvs-image-alert mt-2"
			v-if="showWarning && !isProcessing && !isVerified"
		>
			<img src="@/assets/newdesign/cvs/redInfo.svg" alt="" />
			We are unable to verify you, Please try changing the angle of lights.
		</span>
		<CameraAcessModal
			:showModal="cameraAcesss"
			@close="askCameraPermission()"
		/>
	</section>
</template>

<script>
import {
	cvsImageCapture,
} from "@/utils/apiFunctions";
import lessDelaywarningModal from "@/components/mixin/toast";
import CameraAcessModal from "@/views/Dashboard/modals/CameraAcessModal.vue";
import { Capacitor } from "@capacitor/core";
import { Camera } from "@capacitor/camera";
import axios from "axios";
export default {
	mixins: [lessDelaywarningModal],
	data() {
		return {
			showWarning: false,
			isProcessing: false,
			isVerified: false,
			isPhotoTaken: false,
			capturedImage: null,
			uuid: null,
			cameraAcesss: false,
			stream: null,
			testStreams: null,
		};
	},
	components: {
		CameraAcessModal,
	},
	created() {
		if (
			sessionStorage.getItem("verificationUUID") &&
			Number(localStorage.getItem("timer")) == 600
		) {
			this.uuid = sessionStorage.getItem("verificationUUID");
		} else {
			if (sessionStorage.getItem("verificationUUID")) {
				this.$router.push({
					name: "IdCapture",
					query: {
						uuid: sessionStorage.getItem("verificationUUID"),
					},
				});
			} else {
				this.$router.go(-1);
			}
		}
		this.askCameraPermission();
	},
	beforeDestroy() {
		if (this.stream) {
			this.stream.getTracks().forEach((track) => track.stop());
		}
		if (this.testStreams) {
			this.testStreams.getTracks().forEach((track) => track.stop());
		}
	},
	methods: {
		async askCameraPermission() {
			try {
				if (Capacitor.isNativePlatform()) {
					await Camera.requestPermissions({ permissions: ["camera"] });
				}
				this.testStreams = await navigator.mediaDevices.getUserMedia({
					video: { facingMode: "user" },
					audio: false,
				});
				this.cameraAcesss = false;
				this.createCameraElement();
			} catch (err) {
				this.cameraAcesss = true;
				console.error("Camera permission denied", err);
			}
		},
		async createCameraElement() {
			try {
				const devices = await navigator.mediaDevices.enumerateDevices();
				const videoDevices = devices.filter((d) => d.kind === "videoinput");

				for (const device of videoDevices) {
					const stream = await navigator.mediaDevices.getUserMedia({
						video: {
							deviceId: { exact: device.deviceId },
							width: { ideal: 1280 },
							height: { ideal: 720 },
						},
						audio: false,
					});

					const video = this.$refs.camera;
					video.srcObject = stream;
					video.style.display = "block";

					await new Promise((resolve) => {
						video.onloadedmetadata = () => {
							video.play();

							// Wait a bit for dimensions to stabilize
							setTimeout(() => {
								const w = video.videoWidth;
								const h = video.videoHeight;

								if (w > 100 && h > 100) {
									this.stream = stream;
									this.takePhotoAfterDelay();
									resolve();
								} else {
									stream.getTracks().forEach((t) => t.stop());
									resolve();
								}
							}, 300);
						};
					});

					if (this.stream) break;
				}

				if (!this.stream) {
					console.error("❌ No working camera found.");
					this.cameraAcesss = true;
				}
			} catch (err) {
				console.error("🎥 Camera access error:", err);
				this.cameraAcesss = true;
			}
		},
		takePhotoAfterDelay() {
			this.isPhotoTaken = false;
			setTimeout(() => {
				this.takePhoto();
			}, 6000);
		},
		isMacSafari() {
			const ua = navigator.userAgent;

			const isMacSafari =
				ua.includes("Macintosh") && /^((?!chrome|android).)*safari/i.test(ua);

			const isIOSSafari =
				/(iPhone|iPad|iPod)/.test(ua) && /^((?!crios|fxios|opios).)*safari/i.test(ua);

			return isMacSafari || isIOSSafari;
		},
		async takePhoto() {
			this.isProcessing = true;
			const canvas = this.$refs.canvas;
			const camera = this.$refs.camera;

			const videoWidth = camera.videoWidth;
			const videoHeight = camera.videoHeight;

			canvas.width = videoWidth;
			canvas.height = videoHeight;

			const context = canvas.getContext("2d");
			context.drawImage(camera, 0, 0, videoWidth, videoHeight);

			const src = canvas.toDataURL("image/png");
			const file = this.dataURLtoFile(src, "selfie.png");

			this.capturedImage = file;
			this.isPhotoTaken = true;

			const { CancelToken } = axios;
			const source = CancelToken.source();

			const skipFaceDetection = this.isMacSafari();
			let res = { data: { score: 1 } }; // default to success if skipping

			try {
				if (!skipFaceDetection) {
					const formData = new FormData();
					formData.append("image", file);

					res = await axios.post(
						"https://proctor.hire3x.com/face_detection/",
						formData,
						{ cancelToken: source.token }
					);
				} else {
					console.log("Samsung or Safari detected — skipping face detection.");
				}

				this.isPhotoTaken = skipFaceDetection || res.data.score * 100 >= 75;

				if (this.isPhotoTaken) {
					const formData2 = new FormData();
					formData2.append("uuid", this.uuid);
					formData2.append("candidateImage", this.capturedImage);

					const imageRes = await cvsImageCapture(formData2);
					if (imageRes.status === 200) {
						this.isVerified = true;
						setTimeout(() => {
							this.$emit("go-to-screen-rec");
						}, 2000);
					} else {
						this.showWarning = true;
						this.takePhotoAfterDelay();
					}
				} else {
					this.showWarning = true;
					this.takePhotoAfterDelay();
				}
			} catch (error) {
				this.showWarning = true;
				this.takePhotoAfterDelay();
				this.lessDelaywarningModal(
					"Error",
					"Unable to take a picture, trying to recapture your face in 6 seconds."
				);
				console.error(error);
			} finally {
				this.isProcessing = false;
			}
		},
		dataURLtoFile(dataurl, filename) {
			let arr = dataurl.split(","),
				mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]),
				n = bstr.length,
				u8arr = new Uint8Array(n);

			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}

			return new File([u8arr], filename, { type: mime });
		},
	},
};
</script>

<style scoped>
.lap-margins {
	margin-top: 3rem;
	margin-bottom: 3rem;
}
/* mobile screen design starts here */
@media (max-width: 1028px) {
	.cvs-grey-txt {
		font-size: 12px;
	}
	.mob-margins {
		margin-top: 1rem;
		margin-bottom: 1rem;
	}
}
</style>
